<template>
    <div class="black">
        <page-title title="Markets" />
        <v-tabs height="65" :icons-and-text="$breakpoint.smAndDown">
            <v-tabs-slider color=""></v-tabs-slider>

            <v-container>
                <v-row class="fill-height mt-0 pl-5">
                    <v-tab
                        v-for="(tab, i) in tabs.items"
                        :key="i"
                        :to="tab.link"
                        class="caption px-3"
                    >
                        <div class="pr-7 pb-5">
                            <v-img
                                style="position: absolute"
                                :width="$breakpoint.smAndUp ? '20' : '20'"
                                class="mr-1"
                                :src="`${CDN_IMG_URL}/sportsbook-categories/${tab.icon}.webp`"
                            ></v-img>
                        </div>
                        {{ $t(tab.text) }}
                    </v-tab>
                </v-row>
            </v-container>
        </v-tabs>
        <!-- <sportsbook-category></sportsbook-category> -->
        <v-container class="black">
            <v-row align="stretch" class="fill-height mt-0 ml-1">
                <v-btn
                    v-for="game in games"
                    :key="game.link"
                    :to="`/markets/sportsbook/${game.link}`"
                    active-class="activeclasstab"
                    class="caption ma-1 toptabclass text-white"
                >
                    <div class="pr-7 pb-5">
                        <v-img
                            style="position: absolute"
                            :width="$breakpoint.smAndUp ? '20' : '20'"
                            class="mr-1"
                            :src="`${CDN_IMG_URL}/sportsbook-categories/${game.icon}.webp`"
                            :alt="game.alt"
                        ></v-img>
                    </div>

                    {{ $t(game.tab) }}
                </v-btn>
            </v-row>
        </v-container>
        <Cricket v-if="gameName === 'Cricket'" />
        <Football v-if="gameName === 'Football'" />
        <Tennis v-if="gameName === 'Tennis'" />
        <horse-racing v-if="gameName === 'Horse-Racing'" />
    </div>
</template>

<script>
import Cricket from "@/components/fairplay/markets/Cricket/Cricket"
import Football from "@/components/fairplay/markets/Football/Football"
import Tennis from "@/components/fairplay/markets/Tennis/Tennis"
import HorseRacing from "@/components/fairplay/markets/HorseRacing/HorseRacing"
import PageTitle from "@/components/PageTitle"
export default {
    components: {
        // SportsbookCategory,
        Cricket,
        Football,
        Tennis,
        HorseRacing,
        // Binary,
        PageTitle
    },
    data() {
        return {
            CDN_IMG_URL: process.env.CDN_IMG_URL,
            tab: 0,
            tabs: {
                settings: {
                    grow: true
                },
                items: [
                    // {
                    //   icon: 'mdi-play-circle',
                    //   text: 'Inplay',
                    //   link: '/inplay'
                    // },
                    {
                        icon: "iconpe-sportsbook",
                        text: "market.menu.sportbook",
                        link: "/markets/sportsbook/Cricket"
                    },
                    {
                        icon: "iconpe-live-casino",
                        text: "market.menu.livecasino",
                        link: "/markets/live-casino/Roulette"
                    },
                    {
                        icon: "iconpe-live-cards",
                        text: "market.menu.livecard",
                        link: "/markets/live-cards"
                    }
                ]
            },
            games: [
                {
                    icon: "cricket",
                    tab: "market.menu.cricket",
                    content: "Cricket",
                    link: "Cricket",
                    alt: "Cricket"
                },
                {
                    icon: "soccer",
                    tab: "market.menu.football",
                    content: "Football",
                    link: "Football",
                    alt: "Football"
                },
                {
                    icon: "tennis",
                    tab: "market.menu.tennis",
                    content: "Tennis",
                    link: "Tennis",
                    alt: "Tennis"
                }
                // {
                //     icon: "horse-racing",
                //     tab: "market.menu.horse",
                //     content: "HorseRacing",
                //     link: "Horse-Racing",
                //     alt: "Horse Racing"
                // }
                // {
                //   icon: 'binary',
                //   tab: 'Binary',
                //   content: 'Binary',
                //   link: 'Binary'
                // }
            ]
        }
    },
    // head() {
    //     return {
    //         meta: [
    //             {
    //                 name: "robots",
    //                 content: "noindex"
    //             }
    //         ]
    //     }
    // },
    computed: {
        gameName() {
            return this.$route.params.id
        }
    }
}
</script>

<style lang="scss">
.activeclasstab {
    border-bottom: 2px solid #f36c20;
    border-radius: 0px;
    background-color: black !important;
    &::before {
        opacity: 0 !important;
    }
}
.toptabclass {
    border-radius: 2px;
}
</style>
